export class CreateActionApprovalRuleResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "actionApprovalRule",
            "baseName": "actionApprovalRule",
            "type": "ActionApprovalRule",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateActionApprovalRuleResponse.attributeTypeMap;
    }
    constructor() {
    }
}
